/**
 * Created by Jie Gao on 2021-02-22.
 */
import {TimelineLite} from "gsap";
import {GGParsedGameData} from "../../server/data/GGParsedGameData";
import {UpgradeFSIntroView} from "./UpgradeFSIntroView";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {GGGameModuleConfig} from "../../GGGameModuleConfig";
import {GGGameMode} from "../../gamemode/GGGameMode";
import {GGGameConfig} from "../../GGGameConfig";

export class UpgradeFSIntro extends WinPresentationController {
    protected _view:UpgradeFSIntroView;
    private _roundType:number = 0;
    private _timeline:TimelineLite | null;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "UpgradeFSIntro", skippable : false});
        this._view = new UpgradeFSIntroView();
    }

    protected hasWin():boolean {
        // #576
        if (GGGameConfig.instance.FAULTY_WIN_CAP) {
            return false;
        }

        const isUpgrade:boolean = this._roundType === 1 && ((<GGParsedGameData>this._gameData)!.nextMode === GGGameMode.FREESPIN_SUPER);
        return isUpgrade;
    }

    protected parseFeatureGameData(data:GGParsedGameData):void {
        this._roundType = data.roundType;
    }

    protected startWinPresentation():void {
        this._timeline = new TimelineLite();
        this._timeline.add([
            () => GGGameModuleConfig.soundPlayer.playUpgradeFSAmbianceSound(),
            this._view.show(<GGParsedGameData>this._gameData!)
        ]);
        this._timeline.add(() => this.finish());
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(isAborted) {
            if(this._timeline) {
                if(this._timeline.isActive()) {
                    this._timeline.pause();
                }
                this._timeline.kill();
            }
        }
        this._view.stopPresentation();
        this._timeline = null;
    }
}